var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossMarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "#F04248",
    fillOpacity: 0.15
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1306_38414",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 5,
    width: 31,
    height: 30
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.875,
    y: 5.375,
    width: 29.25,
    height: 29.25,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1306_38414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4 25L20 21.4L23.6 25L25 23.6L21.4 20L25 16.4L23.6 15L20 18.6L16.4 15L15 16.4L18.6 20L15 23.6L16.4 25ZM20 30C18.6167 30 17.3167 29.7373 16.1 29.212C14.8833 28.6873 13.825 27.975 12.925 27.075C12.025 26.175 11.3127 25.1167 10.788 23.9C10.2627 22.6833 10 21.3833 10 20C10 18.6167 10.2627 17.3167 10.788 16.1C11.3127 14.8833 12.025 13.825 12.925 12.925C13.825 12.025 14.8833 11.3123 16.1 10.787C17.3167 10.2623 18.6167 10 20 10C21.3833 10 22.6833 10.2623 23.9 10.787C25.1167 11.3123 26.175 12.025 27.075 12.925C27.975 13.825 28.6873 14.8833 29.212 16.1C29.7373 17.3167 30 18.6167 30 20C30 21.3833 29.7373 22.6833 29.212 23.9C28.6873 25.1167 27.975 26.175 27.075 27.075C26.175 27.975 25.1167 28.6873 23.9 29.212C22.6833 29.7373 21.3833 30 20 30Z",
    fill: "#F04248"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossMarkIcon);
export default __webpack_public_path__ + "static/media/CrossMarkIcon.583b1e3081134fce64a8dee87cc65e4a.svg";
export { ForwardRef as ReactComponent };